type Locale = "ja" | "en";

function detectLocale(): Locale {
  if (typeof navigator === "undefined") return "ja";
  const langs = navigator.languages ?? [navigator.language];
  for (const lang of langs) {
    if (!lang) continue;
    if (lang.toLowerCase().startsWith("ja")) return "ja";
    if (lang.toLowerCase().startsWith("en")) return "en";
  }
  return "ja";
}

export const locale: Locale = detectLocale();

const dict = {
  ja: {
    appTitleShort: "SSSビュアー",
    appTitleLong: "【流星3】シークレットサテライトサーバービュアー",
    loading: "読み込み中…",
    selectServerPrompt: "サーバを選択してください",
    supportDeveloper: "🛠️Support the developer",
    typeSatellite: "サテライトサーバー",
    typeMeteor: "流星サーバー",
    favorites: "お気に入り",
    addToFavorites: "お気に入りに追加",
    removeFromFavorites: "お気に入りから外す",
    customScreen: "カスタム画面",
    customScreenHelp: "カスタム画面の説明",
    customScreenPosition: "カスタム画面位置",
    cardPool: "カードプール",
    serverAddress: "サーバアドレス",
  },
  en: {
    appTitleShort: "SSS Viewer",
    appTitleLong: "[Star Force 3] Secret Satellite Server Viewer",
    loading: "Loading…",
    selectServerPrompt: "Select a server",
    supportDeveloper: "🛠️Support the developer",
    typeSatellite: "Satellite Server",
    typeMeteor: "Meteor Server",
    favorites: "Favorites",
    addToFavorites: "Add to favorites",
    removeFromFavorites: "Remove from favorites",
    customScreen: "Custom Screen",
    customScreenHelp: "About the Custom Screen",
    customScreenPosition: "Custom Screen Position",
    cardPool: "Card Pool",
    serverAddress: "Server Address",
  },
} as const;

export type TranslationKey = keyof typeof dict["ja"];

export function t(key: TranslationKey): string {
  return dict[locale][key];
}

const SERVER_NAME_EN: Record<string, string> = {
  アルファ: "Alpha",
  ベータ: "Beta",
  ガンマ: "Gamma",
  デルタ: "Delta",
  イプシロン: "Epsilon",
  ゼータ: "Zeta",
  イータ: "Eta",
  シータ: "Theta",
  イオタ: "Iota",
  カッパ: "Kappa",
  ラムダ: "Lambda",
  ミュー: "Mu",
  ニュー: "Nu",
  クサイ: "Xi",
  オミクロン: "Omicron",
  パイ: "Pi",
  ロー: "Rho",
  シグマ: "Sigma",
  タウ: "Tau",
  ユプシロン: "Upsilon",
  ファイ: "Phi",
  カイ: "Chi",
  プサイ: "Psi",
  オメガ: "Omega",
};

export function localizeServerName(name: string): string {
  if (locale === "en") {
    return SERVER_NAME_EN[name] ?? name;
  }
  return name;
}
